import { sanitizeRichHtml } from '~/utils/sanitizeRichHtml';

type HtmlContentProps = {
  html: string | undefined | null;
} & React.HTMLAttributes<HTMLDivElement>;

export default function HtmlContent({ html, ...others }: HtmlContentProps) {
  return (
    <span
      {...others}
      dangerouslySetInnerHTML={{
        __html: sanitizeRichHtml(html ?? ''),
      }}
    />
  );
}
